import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Motion";
import { CtaBanner, PageHero } from "@/components/Sections";
import { SERVICES } from "@/lib/content";

const Services = () => (
  <>
    <Seo
      title="Ydelser — Erhvervsmaling, nybyggeri, renovering & underentreprise | Al Maler Mester ApS"
      description="Se vores malerydelser til erhverv: erhvervsmaling, maling af kontor og erhvervslokaler, nybyggeri, renovering, flyttelejemål, spartling og maler-underentreprise til byggeprojekter."
    />
    <PageHero
      overline="Ydelser · Kun erhverv"
      title={
        <>
          Maleropgaver for erhverv —{" "}
          <span className="font-editorial italic font-medium text-signal">fra enkeltopgave til entreprise</span>
        </>
      }
      lead="Vi udfører alle former for professionelt malerarbejde for virksomheder og byggeprojekter. Uanset om opgaven er en enkelt afdeling eller en samlet malerentreprise, leverer vi et ensartet og professionelt resultat."
      image="/images/corridor.jpg"
    />
    <section className="max-w-[1440px] mx-auto px-5 md:px-10 pb-24 md:pb-36">
      <div className="border-t border-ink/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.nr} y={24}>
            <div
              data-testid={`service-row-${s.nr}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center py-12 md:py-16 border-b border-ink/10 group"
            >
              <div className="md:col-span-1">
                <span className="font-editorial italic text-2xl text-signal">({s.nr})</span>
              </div>
              <div className="md:col-span-6">
                <h2 className="font-cabinet text-2xl md:text-3xl font-bold tracking-tight group-hover:text-signal transition-colors duration-300">
                  {s.title}
                </h2>
                <p className="mt-4 text-base text-soot leading-relaxed max-w-xl">{s.desc}</p>
                <Link
                  to="/kontakt"
                  data-testid={`service-quote-${s.nr}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold border-b border-ink pb-1 hover:text-signal hover:border-signal transition-colors duration-300"
                >
                  Indhent tilbud på {s.title.toLowerCase()}
                  <ArrowUpRight size={15} weight="bold" />
                </Link>
              </div>
              <div className="md:col-span-5">
                <div className="grain overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-[240px] md:h-[280px] object-cover grayscale group-hover:grayscale-0 group-hover:scale-[1.03] transition-[filter,transform] duration-700"
                  />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
    <CtaBanner
      title="Skal vi vurdere jeres næste maleropgave?"
      text="Send os en kort beskrivelse af projektet – så vender vi tilbage med et konkret og uforpligtende tilbud."
    />
  </>
);

export default Services;
